// extracted by mini-css-extract-plugin
export var mainWrapper = "layout-module--main-wrapper--C2h+G";
export var linksWrapper = "layout-module--links-wrapper--XK1om";
export var iconLink = "layout-module--icon-link--k8l-u";